import { ADVERT_PROMO_CAMPAIGN_SET } from 'rebook/apps/advert/constants';


export default function promoCampaign(state = null, action) {
  switch (action.type) {
    case ADVERT_PROMO_CAMPAIGN_SET:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
